import React from "react";

// matches an @mention token: @ followed by a username (letters, digits, _ -). Capturing group
// so split() keeps the matched tokens. A separate anchored (non-global) regex is used for the
// per-part test, since a global regex's .test() is stateful via lastIndex.
const MENTION_SPLIT_RE = /(@[a-zA-Z0-9_-]+)/g;
const MENTION_TOKEN_RE = /^@[a-zA-Z0-9_-]+$/;

/**
 * Render message text with @mentions highlighted. Splits the content on @username tokens and
 * wraps each in an accent-styled span; everything else renders as plain text. Highlighting is
 * cosmetic — there are no notification side-effects (per the chosen scope).
 */
export function renderWithMentions(content: string): React.ReactNode {
  if (!content || content.indexOf("@") === -1) return content;
  const parts = content.split(MENTION_SPLIT_RE);
  return parts.map((part, i) =>
    MENTION_TOKEN_RE.test(part) ? (
      <span key={i} className="font-bold text-accent">
        {part}
      </span>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    ),
  );
}
